import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchCategories } from "../../services/categoriesService";

/**
 * Loads the live category taxonomy from Firestore once on app start and
 * pushes it into the Redux store. Renders nothing. On failure the store keeps
 * its bundled static fallback so navigation never breaks.
 */
const CategoriesLoader = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let active = true;
    fetchCategories()
      .then((tree) => {
        if (active) dispatch({ type: "SET_CATEGORIES", payload: tree });
      })
      .catch((err) => {
        console.error("Failed to load categories from Firestore:", err);
        if (active) dispatch({ type: "CATEGORIES_LOAD_FAILED" });
      });
    return () => {
      active = false;
    };
  }, [dispatch]);

  return null;
};

export default CategoriesLoader;
